import React, { useEffect, useRef, useState } from "react";
import ZeroPayCheckoutDemo from "../../images/ZeroPayCheckoutDemo.mp4";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";

function FasterCheckoutsSection() {
  const animatedSVGRef = useRef(null);
  const mobileAnimatedSVGRef = useRef(null);
  const animatedSVGContainerRef = useRef(null);
  const fasterCheckoutsSectionRef = useRef(null);
  const higherConversionRatesSectionRef = useRef(null);
  const increasedAverageOrderValueSectionRef = useRef(null);
  const attractNewCustomersSectionRef = useRef(null);
  const lessDropoutsSectionRef = useRef(null);

  const [deviceWidth, setDeviceWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setDeviceWidth(window.innerWidth);
      addFlowingAnimationToSVG();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const addFlowingAnimationToSVG = () => {
    const path = animatedSVGRef.current.querySelector("path");
    var mobilePath = null;

    const svgContainer = animatedSVGContainerRef.current;
    const svgContainerRect = svgContainer.getBoundingClientRect();
    // Start Position of SVG
    const positionY = svgContainerRect.top + window.scrollY;

    const scrollDistance = window.scrollY;
    const totalDistance = positionY - window.innerHeight;

    const percentage = scrollDistance / totalDistance;

    const pathLength = path.getTotalLength();

    path.style.strokeDasharray = pathLength;

    if (deviceWidth >= 1280) {
      path.style.strokeDashoffset = `${
        pathLength * (1 - percentage) - (scrollDistance - 400)
      }`;
    } else if (deviceWidth >= 640) {
      path.style.strokeDashoffset = `${
        pathLength * (1 - percentage) - (scrollDistance - 600)
      }`;
    } else {
      mobilePath = mobileAnimatedSVGRef.current.querySelector("path");

      path.style.strokeDashoffset = `${
        pathLength * (1 - percentage) - (scrollDistance - 1700)
      }`;

      mobilePath.style.strokeDasharray = pathLength;
      mobilePath.style.strokeDashoffset = `${
        pathLength * (1 - percentage) - (scrollDistance - 400)
      }`;
    }
  };

  useGSAP(() => {
    gsap.from(fasterCheckoutsSectionRef.current, {
      scrollTrigger: {
        trigger: fasterCheckoutsSectionRef.current,
        start: "top 80%",
        end: "bottom 20%",
        scrub: false,
        toggleActions: "play none none reverse",
      },
      opacity: 0,
      y: 100,
      duration: 1,
      ease: "sine.out",
    });

    gsap.from(higherConversionRatesSectionRef.current, {
      scrollTrigger: {
        trigger: higherConversionRatesSectionRef.current,
        start: "top 80%",
        end: "bottom 20%",
        scrub: false,
        toggleActions: "play none none reverse",
      },
      opacity: 0,
      y: 100,
      duration: 1,
      ease: "sine.out",
    });

    gsap.from(increasedAverageOrderValueSectionRef.current, {
      scrollTrigger: {
        trigger: increasedAverageOrderValueSectionRef.current,
        start: "top 80%",
        end: "bottom 20%",
        scrub: false,
        toggleActions: "play none none reverse",
      },
      opacity: 0,
      y: 100,
      duration: 1,
      ease: "sine.out",
    });

    gsap.from(attractNewCustomersSectionRef.current, {
      scrollTrigger: {
        trigger: attractNewCustomersSectionRef.current,
        start: "top 80%",
        end: "bottom 20%",
        scrub: false,
        toggleActions: "play none none reverse",
      },
      opacity: 0,
      y: 100,
      duration: 1,
      ease: "sine.out",
    });

    gsap.from(lessDropoutsSectionRef.current, {
      scrollTrigger: {
        trigger: lessDropoutsSectionRef.current,
        start: "top 80%",
        end: "bottom 20%",
        scrub: false,
        toggleActions: "play none none reverse",
      },
      opacity: 0,
      y: 100,
      duration: 1,
      ease: "sine.out",
    });
  });

  useEffect(() => {
    window.addEventListener("scroll", addFlowingAnimationToSVG);

    return () => {
      window.removeEventListener("scroll", addFlowingAnimationToSVG);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const commonStyles = {
    iconSection: "flex items-center gap-x-3.5 sm:gap-x-2.5 xl:gap-x-3.5",
    icon: "w-[27px] xl:w-[39.2px] h-[24px] xl:h-[34px] drop-shadow-[3px_4px_0_black]",
    largeNumberText:
      "text-[60px] xl:text-[70px] font-HalvarBreitMedium text-black leading-[69.48px] xl:leading-[81px] -tracking-[2%]",
    heading:
      "text-[26px] xl:text-[33px] font-HalvarBreitBold text-black leading-[30px] xl:leading-[38px]",
    paragraph:
      "text-sm xl:text-lg font-HalvarBreitRegular text-black leading-[24px] -tracking-[2%]",
  };

  return (
    <section className="relative flex flex-col" ref={animatedSVGContainerRef}>
      {/* Grey Path */}
      {/* Desktop */}
      <svg
        width="917"
        height="2475"
        viewBox="0 0 917 2475"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="hidden xl:block absolute top-0 -left-80 right-0 mx-auto z-[1]"
      >
        <path
          d="M396 2V142C396 169.614 373.614 192 346 192H52C24.3858 192 2 214.386 2 242V568.5C2 596.114 24.3858 618.5 52 618.5H476C503.614 618.5 526 640.886 526 668.5V1058.5C526 1086.11 548.386 1108.5 576 1108.5H864.5C892.114 1108.5 914.5 1130.89 914.5 1158.5V1462.5C914.5 1490.11 892.114 1512.5 864.5 1512.5H69C41.3857 1512.5 19 1534.89 19 1562.5V1869C19 1896.61 41.3858 1919 69 1919H476C503.614 1919 526 1941.39 526 1969V2473"
          stroke="black"
          strokeOpacity="0.1"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      {/* Tablet */}
      <svg
        width="497"
        height="2438"
        viewBox="0 0 497 2438"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="hidden sm:block xl:hidden absolute -top-14 -left-28 right-0 mx-auto z-[1]"
      >
        <path
          d="M224.705 2V98C224.705 115.673 210.379 130 192.706 130H34.2837C16.6106 130 2.2837 144.327 2.2837 162V496.358C2.2837 496.437 2.22019 496.5 2.14185 496.5V496.5C2.06351 496.5 2 496.564 2 496.642V676.5C2 694.173 16.3269 708.5 34 708.5H462.5C480.173 708.5 494.5 722.827 494.5 740.5V1025C494.5 1042.67 480.173 1057 462.5 1057H153C135.327 1057 121 1071.33 121 1089V1387.5C121 1405.17 135.327 1419.5 153 1419.5H411.64C429.313 1419.5 443.64 1433.83 443.64 1451.5V1803C443.64 1820.67 429.313 1835 411.64 1835H142.5C124.827 1835 110.5 1849.33 110.5 1867V2265C110.5 2282.67 124.827 2297 142.5 2297H261.5C279.173 2297 293.5 2311.33 293.5 2329V2436"
          stroke="black"
          strokeOpacity="0.1"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      {/* Mobile */}
      <svg
        width="333"
        height="3147"
        viewBox="0 0 333 3147"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="block sm:hidden absolute -top-14 left-0 right-0 mx-auto z-[1]"
      >
        <path
          d="M166.679 2V98C166.679 115.673 152.352 130 134.679 130H34.9998C17.3267 130 2.99979 144.327 2.99979 162V496.396C2.99979 496.453 2.95305 496.5 2.8954 496.5V496.5C2.83775 496.5 2.79102 496.547 2.79102 496.604V1134.5C2.79102 1152.17 17.1179 1166.5 34.791 1166.5H299C316.673 1166.5 331 1180.83 331 1198.5V1565.5C331 1583.17 316.673 1597.5 299 1597.5H36.4529C18.7798 1597.5 4.45294 1611.83 4.45294 1629.5V1963C4.45294 1980.67 18.7798 1995 36.4529 1995H295.791C313.464 1995 327.791 2009.33 327.791 2027V2433C327.791 2450.67 313.464 2465 295.791 2465H36.453C18.7798 2465 4.45294 2479.33 4.45294 2497V2974C4.45294 2991.67 18.7798 3006 36.4529 3006H152.5C170.173 3006 184.5 3020.33 184.5 3038V3145"
          stroke="black"
          strokeOpacity="0.1"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      {/* Purple Path */}
      {deviceWidth >= 1280 ? (
        <svg
          width="917"
          height="2475"
          viewBox="0 0 917 2475"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="hidden xl:block absolute top-0 -left-80 right-0 mx-auto z-[1]"
          ref={animatedSVGRef}
          id="animatedSVG"
        >
          <path
            d="M396 2V142C396 169.614 373.614 192 346 192H52C24.3858 192 2 214.386 2 242V568.5C2 596.114 24.3858 618.5 52 618.5H476C503.614 618.5 526 640.886 526 668.5V1058.5C526 1086.11 548.386 1108.5 576 1108.5H864.5C892.114 1108.5 914.5 1130.89 914.5 1158.5V1462.5C914.5 1490.11 892.114 1512.5 864.5 1512.5H69C41.3857 1512.5 19 1534.89 19 1562.5V1869C19 1896.61 41.3858 1919 69 1919H476C503.614 1919 526 1941.39 526 1969V2473"
            stroke="#9B03D0"
            strokeOpacity="1"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : deviceWidth >= 640 ? (
        <svg
          width="497"
          height="2438"
          viewBox="0 0 497 2438"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="hidden sm:block xl:hidden absolute -top-14 -left-28 right-0 mx-auto z-[1]"
          ref={animatedSVGRef}
          id="animatedSVG"
        >
          <path
            d="M224.705 2V98C224.705 115.673 210.379 130 192.706 130H34.2837C16.6106 130 2.2837 144.327 2.2837 162V496.358C2.2837 496.437 2.22019 496.5 2.14185 496.5V496.5C2.06351 496.5 2 496.564 2 496.642V676.5C2 694.173 16.3269 708.5 34 708.5H462.5C480.173 708.5 494.5 722.827 494.5 740.5V1025C494.5 1042.67 480.173 1057 462.5 1057H153C135.327 1057 121 1071.33 121 1089V1387.5C121 1405.17 135.327 1419.5 153 1419.5H411.64C429.313 1419.5 443.64 1433.83 443.64 1451.5V1803C443.64 1820.67 429.313 1835 411.64 1835H142.5C124.827 1835 110.5 1849.33 110.5 1867V2265C110.5 2282.67 124.827 2297 142.5 2297H261.5C279.173 2297 293.5 2311.33 293.5 2329V2436"
            stroke="#9B03D0"
            strokeOpacity="1"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : (
        <>
          <svg
            width="333"
            height="3147"
            viewBox="0 0 333 3147"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="absolute block xl:hidden -top-14 left-0 right-0 mx-auto z-[1]"
            ref={mobileAnimatedSVGRef}
            id="mobileAnimatedSVG"
          >
            <path
              d="M166.679 2V98C166.679 115.673 152.352 130 134.679 130H34.9998C17.3267 130 2.99979 144.327 2.99979 162V496.396C2.99979 496.453 2.95305 496.5 2.8954 496.5V496.5C2.83775 496.5 2.79102 496.547 2.79102 496.604V1134.5C2.79102 1152.17 17.1179 1166.5 34.791 1166.5H299C316.673 1166.5 331 1180.83 331 1198.5V1565.5C331 1583.17 316.673 1597.5 299 1597.5H36.4529C18.7798 1597.5 4.45294 1611.83 4.45294 1629.5V1963C4.45294 1980.67 18.7798 1995 36.4529 1995H295.791C313.464 1995 327.791 2009.33 327.791 2027V2433C327.791 2450.67 313.464 2465 295.791 2465H36.453C18.7798 2465 4.45294 2479.33 4.45294 2497V2974C4.45294 2991.67 18.7798 3006 36.4529 3006H152.5C170.173 3006 184.5 3020.33 184.5 3038V3145"
              stroke="#9B03D0"
              strokeWidth="4"
              strokeOpacity="0"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <svg
            width="333"
            height="3147"
            viewBox="0 0 333 3147"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="absolute block xl:hidden -top-14 left-0 right-0 mx-auto z-[1]"
            ref={animatedSVGRef}
            id="animatedSVG"
          >
            <path
              d="M166.679 2V98C166.679 115.673 152.352 130 134.679 130H34.9998C17.3267 130 2.99979 144.327 2.99979 162V496.396C2.99979 496.453 2.95305 496.5 2.8954 496.5V496.5C2.83775 496.5 2.79102 496.547 2.79102 496.604V1134.5C2.79102 1152.17 17.1179 1166.5 34.791 1166.5H299C316.673 1166.5 331 1180.83 331 1198.5V1565.5C331 1583.17 316.673 1597.5 299 1597.5H36.4529C18.7798 1597.5 4.45294 1611.83 4.45294 1629.5V1963C4.45294 1980.67 18.7798 1995 36.4529 1995H295.791C313.464 1995 327.791 2009.33 327.791 2027V2433C327.791 2450.67 313.464 2465 295.791 2465H36.453C18.7798 2465 4.45294 2479.33 4.45294 2497V2974C4.45294 2991.67 18.7798 3006 36.4529 3006H152.5C170.173 3006 184.5 3020.33 184.5 3038V3145"
              stroke="#9B03D0"
              strokeWidth="4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </>
      )}

      {/* Faster Checkouts */}
      <section
        ref={fasterCheckoutsSectionRef}
        className="z-[2] flex flex-col sm:flex-row items-center justify-center gap-x-6 xl:gap-x-80 gap-y-14 mt-32 sm:mt-24 xl:mt-32"
      >
        <section className="max-w-[277px] sm:max-w-[285px] xl:max-w-[591px] translate-x-0 xl:translate-x-4">
          <div className={commonStyles.iconSection}>
            <svg
              width="44"
              height="39"
              viewBox="0 0 44 39"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className={commonStyles.icon}
            >
              <g>
                <path
                  d="M39.6163 23.767C39.3233 23.0576 29.0873 5.36399 28.7056 4.8011C24.8035 -0.951952 16.3714 -0.915419 12.4948 4.8011C12.1131 5.36328 1.87708 23.0555 1.5841 23.767C-1.40297 31.0101 7.68477 39.0154 14.8245 31.4435C17.9529 28.1258 23.2393 28.1169 26.3759 31.4435C33.5145 39.0154 42.6023 31.0101 39.6163 23.767Z"
                  fill="#05D362"
                />
                <path
                  d="M39.6163 23.767C39.3233 23.0576 29.0873 5.36399 28.7056 4.8011C24.8035 -0.951952 16.3714 -0.915419 12.4948 4.8011C12.1131 5.36328 1.87708 23.0555 1.5841 23.767C-1.40297 31.0101 7.68477 39.0154 14.8245 31.4435C17.9529 28.1258 23.2393 28.1169 26.3759 31.4435C33.5145 39.0154 42.6023 31.0101 39.6163 23.767Z"
                  stroke="black"
                />
              </g>
            </svg>
            <p className={commonStyles.largeNumberText}>8x</p>
          </div>
          <h2 className={commonStyles.heading}>Faster Checkouts</h2>
          <p className={commonStyles.paragraph}>
            Streamlining your checkout process, with biometrics, instant
            customer recognition & just 1-click to do it all
            <br />
            Reducing friction and making it easier for customers to complete
            their purchases
          </p>
        </section>

        <section className="w-[271px] sm:w-[220px] xl:w-[271px] h-fit border border-black rounded-[10px] shadow-[4px_4px_0_black] overflow-hidden">
          <video
            src={ZeroPayCheckoutDemo}
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            className="select-none w-full"
          ></video>
        </section>
      </section>

      {/* Higher Conversion Rates */}
      <section
        ref={higherConversionRatesSectionRef}
        className="z-[2] flex items-center justify-center mt-36 sm:mt-40 xl:mt-20"
      >
        <section className="max-w-[277px] sm:max-w-[415px] xl:max-w-[660px] translate-x-0 sm:-translate-x-12 xl:translate-x-[17.5rem]">
          <div className={commonStyles.iconSection}>
            <svg
              width="44"
              height="39"
              viewBox="0 0 44 39"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className={commonStyles.icon}
            >
              <g>
                <path
                  d="M39.6163 23.767C39.3233 23.0576 29.0873 5.36399 28.7056 4.8011C24.8035 -0.951952 16.3714 -0.915419 12.4948 4.8011C12.1131 5.36328 1.87708 23.0555 1.5841 23.767C-1.40297 31.0101 7.68477 39.0154 14.8245 31.4435C17.9529 28.1258 23.2393 28.1169 26.3759 31.4435C33.5145 39.0154 42.6023 31.0101 39.6163 23.767Z"
                  fill="#05D362"
                />
                <path
                  d="M39.6163 23.767C39.3233 23.0576 29.0873 5.36399 28.7056 4.8011C24.8035 -0.951952 16.3714 -0.915419 12.4948 4.8011C12.1131 5.36328 1.87708 23.0555 1.5841 23.767C-1.40297 31.0101 7.68477 39.0154 14.8245 31.4435C17.9529 28.1258 23.2393 28.1169 26.3759 31.4435C33.5145 39.0154 42.6023 31.0101 39.6163 23.767Z"
                  stroke="black"
                />
              </g>
            </svg>
            <p className={commonStyles.largeNumberText}>68%</p>
          </div>
          <h2 className={commonStyles.heading}>Higher Conversion Rates</h2>
          <p className={commonStyles.paragraph}>
            STRABL give your customers multiple payment options, ZERO forms to
            fill & a frictionless process
            <br />
            Keeping customers engaged, and getting them to checkout faster
            results in higherrrr conversions
          </p>
        </section>
      </section>

      {/* Increased Average Order Value */}
      <section
        ref={increasedAverageOrderValueSectionRef}
        className="z-[2] flex items-center justify-center mt-32 sm:mt-36 xl:mt-40"
      >
        <section className="max-w-[277px] sm:max-w-[410px] xl:max-w-[660px] translate-x-0 sm:translate-x-16 xl:-translate-x-28">
          <div className={commonStyles.iconSection}>
            <svg
              width="44"
              height="39"
              viewBox="0 0 44 39"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className={commonStyles.icon}
            >
              <g>
                <path
                  d="M39.6163 23.767C39.3233 23.0576 29.0873 5.36399 28.7056 4.8011C24.8035 -0.951952 16.3714 -0.915419 12.4948 4.8011C12.1131 5.36328 1.87708 23.0555 1.5841 23.767C-1.40297 31.0101 7.68477 39.0154 14.8245 31.4435C17.9529 28.1258 23.2393 28.1169 26.3759 31.4435C33.5145 39.0154 42.6023 31.0101 39.6163 23.767Z"
                  fill="#05D362"
                />
                <path
                  d="M39.6163 23.767C39.3233 23.0576 29.0873 5.36399 28.7056 4.8011C24.8035 -0.951952 16.3714 -0.915419 12.4948 4.8011C12.1131 5.36328 1.87708 23.0555 1.5841 23.767C-1.40297 31.0101 7.68477 39.0154 14.8245 31.4435C17.9529 28.1258 23.2393 28.1169 26.3759 31.4435C33.5145 39.0154 42.6023 31.0101 39.6163 23.767Z"
                  stroke="black"
                />
              </g>
            </svg>
            <p className={commonStyles.largeNumberText}>57%</p>
          </div>
          <h2 className={commonStyles.heading}>
            Increased Average Order Value
          </h2>
          <p className={commonStyles.paragraph}>
            With Zero Pay Checkouts, your customer will have even more reasons
            to trust your business and with the freedom to pay later with 0
            upfront payment, customers can order ALOT more
          </p>
        </section>
      </section>

      {/* Attract New Customers */}
      <section
        ref={attractNewCustomersSectionRef}
        className="z-[2] flex items-center justify-center mt-32 xl:mt-48"
      >
        <section className="max-w-[277px] sm:max-w-[400px] xl:max-w-[635px] translate-x-0 sm:-translate-x-24 xl:-translate-x-60">
          <div className={commonStyles.iconSection}>
            <svg
              width="44"
              height="39"
              viewBox="0 0 44 39"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className={commonStyles.icon}
            >
              <g>
                <path
                  d="M39.6163 23.767C39.3233 23.0576 29.0873 5.36399 28.7056 4.8011C24.8035 -0.951952 16.3714 -0.915419 12.4948 4.8011C12.1131 5.36328 1.87708 23.0555 1.5841 23.767C-1.40297 31.0101 7.68477 39.0154 14.8245 31.4435C17.9529 28.1258 23.2393 28.1169 26.3759 31.4435C33.5145 39.0154 42.6023 31.0101 39.6163 23.767Z"
                  fill="#05D362"
                />
                <path
                  d="M39.6163 23.767C39.3233 23.0576 29.0873 5.36399 28.7056 4.8011C24.8035 -0.951952 16.3714 -0.915419 12.4948 4.8011C12.1131 5.36328 1.87708 23.0555 1.5841 23.767C-1.40297 31.0101 7.68477 39.0154 14.8245 31.4435C17.9529 28.1258 23.2393 28.1169 26.3759 31.4435C33.5145 39.0154 42.6023 31.0101 39.6163 23.767Z"
                  stroke="black"
                />
              </g>
            </svg>
            <p className={commonStyles.largeNumberText}>45%</p>
          </div>
          <h2 className={commonStyles.heading}>Attract New Customers</h2>
          <p className={commonStyles.paragraph}>
            Turn potential customers to your actual customers.
            <br />
            <br />
            Good experiences are always talked about and if you add some amazing
            features to that... guess what happens?
            <br />
            No more spending stacks of $$$ to acquire new customers!
          </p>
        </section>
      </section>

      {/* Less dropouts */}
      <section
        ref={lessDropoutsSectionRef}
        className="z-[2] flex items-center justify-center mt-28 xl:mt-44"
      >
        <section className="max-w-[277px] sm:max-w-[445px] xl:max-w-[698px] translate-x-0 sm:translate-x-16 xl:translate-x-[19rem]">
          <div className={commonStyles.iconSection}>
            <svg
              width="44"
              height="39"
              viewBox="0 0 44 39"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className={commonStyles.icon}
            >
              <g>
                <path
                  d="M39.6163 11.233C39.3233 11.9424 29.0873 29.636 28.7056 30.1989C24.8035 35.952 16.3714 35.9154 12.4948 30.1989C12.1131 29.6367 1.87708 11.9445 1.5841 11.233C-1.40297 3.98989 7.68477 -4.01543 14.8245 3.55646C17.9529 6.87422 23.2393 6.88309 26.3759 3.55646C33.5145 -4.01543 42.6023 3.98989 39.6163 11.233Z"
                  fill="#FF3075"
                />
                <path
                  d="M39.6163 11.233C39.3233 11.9424 29.0873 29.636 28.7056 30.1989C24.8035 35.952 16.3714 35.9154 12.4948 30.1989C12.1131 29.6367 1.87708 11.9445 1.5841 11.233C-1.40297 3.98989 7.68477 -4.01543 14.8245 3.55646C17.9529 6.87422 23.2393 6.88309 26.3759 3.55646C33.5145 -4.01543 42.6023 3.98989 39.6163 11.233Z"
                  stroke="black"
                />
              </g>
            </svg>

            <p className={commonStyles.largeNumberText}>75%</p>
          </div>
          <h2 className={commonStyles.heading}>Less dropouts</h2>
          <p className={commonStyles.paragraph}>
            Say Goodbye to Abandoned Carts & Failed Transactions
            <br />
            A frustrating checkout with limited options, is a recipe for lost
            sales.
            <br />
            <br />
            STRABL gives your customers all that they need to complete their
            orders.
            <br />
            *Payment Options? Check! *Payment Flexibility? Check!
            <br />
            *Don’t want to fill the same customer form again? Double Check!
          </p>
        </section>
      </section>
    </section>
  );
}

export default FasterCheckoutsSection;
